import { render, staticRenderFns } from "./OpenPage.vue?vue&type=template&id=225c8fae&"
import script from "./OpenPage.vue?vue&type=script&lang=js&"
export * from "./OpenPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports